import { ResolverTag } from '@ps/web-core-enums';
import { useTrackers } from '@ps/web-shared-analytics';
import { StarsButton, Translation } from '@ps/web-shared-components';
import React, { useEffect } from 'react';
import { useDispatch } from 'react-redux';

import type { LocationStateProps } from '@swf/casino';
import ResolverLink from '@swf/components/ResolverLink/ResolverLink';
import Body from '@swf/components/StarsModal/components/Body';
import CloseButton from '@swf/components/StarsModal/components/CloseButton';
import Header from '@swf/components/StarsModal/components/Header/Header';
import useSearchParams from '@swf/core/hooks/useSearchParams';
import type { Dispatch } from '@swf/core/store';
import { statusKey } from '@swf/core/utils';

import {
  TXTACL_You_cannot_access_another_game_ELL,
  TXTCLI_Error,
  TXTCLI_OK
} from './GameSessionError.messages.json';
import styles from './GameSessionError.scss';

const GameSessionError: React.FC = () => {
  const { errorViewed } = useTrackers();
  const state = useSearchParams<LocationStateProps>();
  const { statusCode } = state;
  const {
    modal: { close }
  } = useDispatch<Dispatch>();

  useEffect(() => errorViewed({ errorCode: statusKey(statusCode) }), [errorViewed, statusCode]);

  return (
    <>
      <Header>
        {<Translation {...TXTCLI_Error} />}
        <CloseButton />
      </Header>
      <Body className={styles.body}>
        <Translation
          tagName="p"
          values={{
            a: (msg: React.ReactNode) => (
              <ResolverLink resolverTag={ResolverTag.HelpCenterESDecree}>{msg}</ResolverLink>
            )
          }}
          {...TXTACL_You_cannot_access_another_game_ELL}
        />
        <StarsButton className={styles.button} onClick={() => close()} translation={TXTCLI_OK} />
      </Body>
    </>
  );
};

export default GameSessionError;
